import { createSlice } from "@reduxjs/toolkit";
import notificationApi from "./api";
import { toast } from "react-toastify";

const initialState = {
  notifications: [],
  pagination: { current: 1, pageSize: 10 },
  isLoading: false,
  isProcessing: false,
  isCompleted: false,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsProcessing: (state, action) => {
      if (action.payload === true) state.isCompleted = false;
      state.isProcessing = action.payload;
    },
    setIsCompleted: (state, action) => {
      state.isCompleted = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    addNotification: (state, action) => {
      state.isCompleted = true;
      state.notifications.unshift(action.payload);
    },
    editNotification: (state, action) => {
      state.isCompleted = true;
      state.notifications = state.notifications.map((notification) =>
        notification._id === action.payload._id ? action.payload : notification
      );
    },
    removeNotification: (state, action) => {
      state.isCompleted = true;
      state.notifications = state.notifications.filter(
        (notification) => notification._id !== action.payload
      );
    },
  },
});

export const {
  setIsLoading,
  setIsCompleted,
  setIsProcessing,
  setNotifications,
  setPagination,
  addNotification,
  editNotification,
  removeNotification,
} = notificationSlice.actions;

export const fetchNotifications = (params) => {
  return async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const data = await notificationApi.getAll(params);
      dispatch(setNotifications(data.data));
      dispatch(setPagination(data.meta));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setIsLoading(false));
    }
  };
};
export const createNotification = (formData) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await notificationApi.create(formData);
      if (data.error) {
        toast.error(data.error.msg);
      } else {
        dispatch(addNotification(data));
        toast.success("Thêm thông báo mới thành công!");
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};
export const updateNotification = (notification, formData) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await notificationApi.update(notification._id, formData);
      if (data.error) {
        toast.error(data.error.msg);
      } else {
        dispatch(editNotification(data));
        toast.success("Cập nhật thông báo thành công!");
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};
export const deleteNotification = (id) => {
  return async (dispatch) => {
    try {
      dispatch(setIsProcessing(true));
      const data = await notificationApi.delete(id);
      if (data.success) {
        dispatch(removeNotification(id));
        toast.success("Xóa thông báo thành công!");
      } else {
        toast.error("Lỗi hệ thống, xóa thông báo thất bại!");
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setIsProcessing(false));
    }
  };
};
export default notificationSlice.reducer;
